import { TabbedPageShell } from '../../../../components/layout/tabbedPageShell';
import QuestionnaireFooter from './QuestionnaireFooter';

import type { QuestionnaireShellProps } from '../types';

export default function QuestionnaireShell({
  tabOptions,
  tabsAriaLabel,
  tabConfigs,
  basePath,
  terminalTabId,
  terminalAction,
  children,
}: QuestionnaireShellProps) {
  return (
    <TabbedPageShell
      tabOptions={tabOptions}
      tabsAriaLabel={tabsAriaLabel}
      errorLabel="Section has validation errors"
      successLabel="Section is complete"
      footer={
        <QuestionnaireFooter
          tabConfigs={tabConfigs}
          basePath={basePath}
          terminalTabId={terminalTabId}
          terminalAction={terminalAction}
        />
      }
    >
      {children}
    </TabbedPageShell>
  );
}
